export const board = {
    data() {
        return {
            passList15: [ 
                {
                    title: "2022, SEVS 15th Curator & Artists",
                    // curator : "임휘재",
                    // name:  "임휘재  김규년  김동우  김휘아  박세연  윤지영  이영미  이을  좌진규 "
                },
            ],
            passList14: [ 
                {
                    title: "2021, SEVS 14th Artists",
                    name: "김여진  김영도  이진솔  오정선  조예지  최민선  현지원  황준하"
                },
            ],
            passList13: [ 
                {
                    title: "2020, SEVS 13th Artists",
                    name: "권수진  김여진  김영도  김종현  김진현  도수진  이진솔  조예지  최민선  최주민  최찬미  현지원"
                },
            ],
            passList12: [ 
                {
                    title: "2019, SEVS 12th Artists",
                    name: "고다현  김진현  오소현  이예진  이혜원  임혜지  최주민"
                },
            ],
            passList11: [
                {
                    title: "2018, SEVS 11th Artists",
                    name: "구의진  오소현  안다은  안대소  이예진  이준석  Soundlucy"
                },
            ],
            passList10: [
                {
                    title: "2017, SEVS 10th Artists",
                    name: "김종구  서진용  이승미  이준석  최홍영"
                },
            ],
            passList9: [
                {
                    title: "2016, SEVS 09th Artists",
                    name: "강민규  김병현  서진용  유승민  이준석  이지연  이채윤  최광제"
                },
            ],
            passList8: [
                {
                    title: "2015, SEVS 08th Artists",
                    name: "강민규  김수종  노희은  박우승  박정은  이채윤  정훈구  조은정  최광제"
                },
            ]
        }
    }
}